import script from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"

import "./PartnersSection.vue?vue&type=style&index=0&id=ee294666&lang=css"

const __exports__ = script;

export default __exports__